import { NextSeo, BlogJsonLd } from 'next-seo';
import PropTypes from 'prop-types';

import AssembleLayout from '@/src/layouts/AssembleLayout';
import MainLayout from '@/src/layouts/MainLayout';
import { blogPostByUIDGet } from '@/src/lib/prismic/queries';
import { urlHostResolver } from '@/src/lib/utils';
import BlogPost from '@/src/views/blog/BlogPost';

export default function BlogPostPage({ doc, preview }) {
  const coverImage = doc?.data?.cover;
  const ogImage = {
    url: coverImage?.url,
    width: coverImage?.dimensions?.width,
    height: coverImage?.dimensions?.height,
    alt: `${doc?.data?.title[0]?.text} | Blog`,
  };

  return (
    <AssembleLayout Layout={MainLayout} Component={BlogPost} doc={doc} preview={preview}>
      <NextSeo
        title={`${doc?.data?.title[0]?.text} | Blog`}
        description={doc?.data?.description}
        openGraph={{
          title: `${doc?.data?.title[0]?.text} | Blog`,
          url: urlHostResolver(`/blog/post/${doc?.uid}`),
          images: [...(coverImage ? [ogImage] : [])], // TODO: Must find a more readable solution
        }}
      />
      <BlogJsonLd
        title={`${doc?.data?.title[0]?.text} | Blog`}
        url={urlHostResolver(`/blog/post/${doc?.uid}`)}
        description={doc?.data?.description}
        images={[`${doc?.data?.cover?.url}`]}
        datePublished={doc?.first_publication_date}
        dateModified={doc?.last_publication_date}
        authorName={doc?.data?.author?.data?.name}
      />
    </AssembleLayout>
  );
}

BlogPostPage.propTypes = {
  doc: PropTypes.object,
  preview: PropTypes.bool,
};

export async function getStaticPaths() {
  return { paths: [], fallback: 'blocking' };
}

export async function getStaticProps(context) {
  const { params, preview = false, previewData = {} } = context;
  const { ref } = previewData;
  const { postUid: blogPostUid } = params;

  const graphQuery = `{
    blog-post {
      cover
      title
      description
      content
      date
      author {
        name
        avatar
      }
      categories {
        category {
          name
          color
        }
      }
    }
  }`;

  const doc = await blogPostByUIDGet({ blogPostUid, graphQuery }, { ref });

  if (!doc) return { notFound: true };

  return {
    props: { doc, preview },
    revalidate: 180,
  };
}
